import { getCarListV2, FuzzySearch } from '@/api/domain/cars'
import { h } from 'vue'
import { TABS, tabList } from './index'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export const OPERATES = ['editCar', 'outCar', 'returnCar', 'careCar', 'fixCar', 'accidentCar', 'prepareCar', 'addInsure', 'addLicense', 'confirmCarInStore', 'dealCar', 'cancelPrepareCar']

// 待处理配置
export const WaitForHandleConfig = ({
  table,
  autoQuery,
  operations,
  getTags,
  cityList,
  remoteCarList,
}) => {
  return {
    formData: {
      list: [{
        el: 'select',
        itemConfig: {
          label: '车牌号',
          prop: 'plateNo',
        },
        elConfig: {
          remote: true,
          clearable: true,
          filterable: true,
          reserveKeyword: true,
          defaultFirstOption: true,
          remoteMethod: remoteCarList,
          placeholder: '请输入',
          options: {
            label: 'plateNo',
            value: 'id',
            list: [],
          },
        },
      }, {
        el: 'input',
        itemConfig: {
          label: 'VIN码',
          prop: 'vin',
        },
        elConfig: {
          clearable: true,
          maxlength: 18,
          placeholder: '请输入',
        },
      }, {
        el: 'input',
        itemConfig: {
          label: '车辆ID',
          prop: 'id',
        },
        elConfig: {
          clearable: true,
          placeholder: '请输入车辆ID',
        },
        directives: [{ name: 'number', arg: 'integer', value: 18 }],
      }, {
        el: 'input',
        itemConfig: {
          label: '发动机号',
          prop: 'engineNo',
        },
        elConfig: {
          clearable: true,
          maxlength: 20,
          placeholder: '请输入',
        },
      }, {
        itemConfig: {
          prop: 'brandSeriesModel',
        },
        elConfig: {
          showModel: true,
          filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
        },
        render: 'CarBrandSeriesModel',
      }, {
        el: 'select',
        itemConfig: {
          label: '运营城市',
          prop: 'adcode',
        },
        elConfig: {
          clearable: true,
          filterable: true,
          reserveKeyword: true,
          defaultFirstOption: true,
          placeholder: '请选择',
          options: {
            label: 'city',
            value: 'adcode',
            list: cityList,
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '车辆标签',
          prop: 'tagId',
        },
        elConfig: {
          clearable: true,
          placeholder: '请选择',
          filterable: false,
          options: {
            label: 'name',
            value: 'id',
            list: [],
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '车源方',
          prop: 'providerId',
        },
        elConfig: {
          clearable: true,
          placeholder: '请选择',
          options: {
            label: 'name',
            value: 'id',
            list: [],
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '电池冷却类型',
          prop: 'coolingMode',
        },
        elConfig: {
          clearable: true,
          placeholder: '请选择',
          filterable: false,
          options: {
            label: 'name',
            value: 'code',
            list: [],
          },
        },
      }, {
        el: 'select',
        itemConfig: {
          label: '所属部门',
          prop: 'deptIdList',
        },
        elConfig: {
          defaultValue: [],
        },
        render: 'DeptTree',
      }],
      exportData: {
        // 导出模板，用于查找对应的导出方法
        // export.js文件中需存在以'export{{exportTemplate}}'命名的导出方法，例如：exportReturnCarOrderList
        exportTemplate: 'CarList',
        // 导出的文件名称
        filename: '车辆管理.xlsx',
        // 资源权限（可选）
        permissionName: 'car_vehicle_export',
      },
      clickSearch: () => {
        getTags && getTags()
      },
      dealWithSearch: (params) => {
        // 品牌车型车系参数处理
        const { brandSeriesModel } = params
        if (brandSeriesModel) {
          const { brandId, seriesId, modelId } = brandSeriesModel
          params.seriesId = seriesId
          params.modelId = modelId
          params.brandId = brandId
        }
        delete params.brandSeriesModel
        // 添加tab参数
        const tabParams = tabList[TABS.WaitForHandle].params
        params = {
          ...params,
          ...tabParams,
        }
        const { groupType, itemType } = autoQuery?.g || {}
        params.groupType = groupType
        params.itemType = itemType
        return params
      },
      customizeReset: () => {
        table.value.setItemData({
          elConfigKey: 'value',
          key: 'brandSeriesModel',
          data: {},
        })
      },
    },
    tableData: {
      columns: [{
        name: 'data',
        columnProps: {
          prop: 'data',
          wordClass: 'wait-for-handle-card',
        },
        render({ row }) {
          const events = {}
          OPERATES.forEach((item) => {
            events[item] = operations[item].handler
          })
          return h('WaitForHandleCard', {
            key: row.id,
            props: {
              data: row,
            },
            on: {
              ...events,
              editUnRentableTags: operations.editUnRentableTag.handler,
            },
          })
        },
      }],
      apiFn: getCarListV2,
      showHeader: false,
      highlightCurrentRow: false,
    },
    isShowDepartment: false,
  }
}
